import React from "react";
import LifeMiles from "./lifemiles";
import AAdvantage from "./aadvantage";
import CashBack from "./cashback";

// TODO: Ajustar esto para que tome país también
const calculadoras = {
  LifeMiles: LifeMiles,
  AAdvantage: AAdvantage,
  CashBack: CashBack
};

// TODO: Cambiar el default
export default props => {
  const Calculadora = calculadoras[props.producto || "LifeMiles"];
  return (
    <>
      <Calculadora {...props} />
    </>
  );
};
